import Fab from "@mui/material/Fab";
import * as React from "react";
import io from "socket.io-client";
import { icons } from "../../assets";
import UserChatDialog from "../chatDialog";

const socket = io.connect(
  "https://trust-telecom-backend-e4655fbdb250.herokuapp.com"
);

const generateRandomId = () => {
  return Math.random().toString(36).substr(2, 9);
};

export default function ChatFloatingBtn({ openChatBoxRef }) {
  const userId = localStorage.getItem("userId") || generateRandomId();

  const handleConnectWithSocket = () => {
    if (userId) {
      localStorage.setItem("userId", userId);
      socket.emit("registerUser", userId);
    }
  };

  return (
    <>
      <Fab
        size="small"
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "25px",
          backgroundColor: "#ffffff",
        }}
        onClick={() => {
          handleConnectWithSocket();
          openChatBoxRef.current.openDialog();
        }}
      >
        <img
          src={icons.circleChatIcon}
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50%",
          }}
        />
      </Fab>
      <UserChatDialog ref={openChatBoxRef} socket={socket} />
    </>
  );
}
